import { ApiService } from '../../shared/services/core/api.service';
import { LoggingService } from '../../shared/services/core/logging.service';
import { tap } from 'rxjs/operators';
import { cacheable } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { FaqSectionStore } from './faq-section.store';
import { FaqSectionModel } from './models/faq-section.model';

@Injectable({ providedIn: 'root' })
export class FaqSectionService {
  constructor(private FaqSectionStore: FaqSectionStore, private api: ApiService, private logService: LoggingService) {}

  /** Fetch all faqs and put them in the store.
   *
   * @param populationId population variant added onto call
   * @param lcid language variant to be displayed
   */

  fetchFaqSection(populationId: number, lcid: number, clubId: number) {
    this.logService.debug(`Fetching FAQs`);

    const request$ = this.api
      .get<FaqSectionModel>(`content/FAQs?clubId=${clubId}&lcid=${lcid}&populationId=${populationId}`)
      .pipe(
        tap((faqSection) => {
          this.FaqSectionStore.upsertMany(faqSection);
        })
      );

    return cacheable(this.FaqSectionStore, request$);
  }
}
